import { Form } from "antd";
import React, { useEffect, useState } from "react";
import {
  getProfessionalInfo,
  updateProfessionalInfo,
} from "../../services/awsServices";
import { SIGNUP_FORM_BASIC } from "../../utils/constant";
import dayjs from "../../utils/myDayjs";
import toastMessage from "../../utils/toastMessage";
import LoadingModal from "../AllModal/LoadingModal";
import GradientButton from "../Button/GradientButton";
import CurrentInput from "../CurrentInput/CurrentInput";
import FormItem from "../Interactions/FormItem";
import { formatDateForAchivement } from "../../utils/utils";
import { useSelector } from "react-redux";

const DATE_FORMAT = import.meta.env.VITE_APP_DATE_FORMAT;
const plusIcon = (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.4987 4.16797V15.8346"
      stroke="#F1F3F4"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.66797 9.9987H16.3346"
      stroke="#F1F3F4"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const NationalBronzeAchievements = () => {
  const [formGenerationInfo, setFormGenerationInfo] = useState(
    SIGNUP_FORM_BASIC["AchievementsInformation"]
  );
  const [userData, setUserData] = useState({});
  const [loading, setLoading] = useState(false);
  // console.log(formGenerationInfo, " = formGene:prof");
  const [form] = Form.useForm();

  const userAllFormsDetails = useSelector(
    (state) => state.user.userAllFormsDetails
  );

  useEffect(()=>{
    setLoading(true);
    const achievement = userAllFormsDetails.find(
      (data) => data.SK === "Achievements#National#Bronze"
    );
    const finalObj = {};
    const formGenerArray = [];
    if(achievement?.Data?.length > 0){
      for (let i = 0, n = achievement?.Data?.length; i < n; i++) {
        Object.keys(achievement?.Data[i]).forEach(key => {
          if(key === 'Date' && achievement?.Data[i][key]){
            const date = formatDateForAchivement(achievement?.Data[i][key]);
            finalObj[`${key+i}`] = date;
          }
          else {
            finalObj[`${key+i}`] = achievement?.Data[i][key];
          }
        });
        formGenerArray.push(formGenerationInfo[0]);
      }
    }
    else {
      formGenerArray.push(formGenerationInfo[0]);
    }
    
    console.log(finalObj, " ===Psyco:Challenge:useEff");
    setUserData(finalObj);
    setFormGenerationInfo(formGenerArray);
    form.setFieldsValue(finalObj);
    setLoading(false);
  }, []);

  // useEffect(() => {
  //   setLoading(true);
  //   getProfessionalInfo()
  //     .then((res) => {
  //       console.log(res, "getProfessionalInfo:serviceResult");
  //       const finalObj = {};
  //       const formGenerArray = [];
  //       if (res.data?.Data?.length > 0) {
  //         for (let i = 0, n = res.data?.Data?.length; i < n; i++) {
  //           Object.keys(res.data?.Data[i]).forEach((key) => {
  //             if (key === "StartDate" || key === "EndDate") {
  //               finalObj[`${key + i}`] = dayjs(res.data?.Data[i][key]);
  //             } else {
  //               finalObj[`${key + i}`] = res.data?.Data[i][key];
  //             }
  //           });
  //           formGenerArray.push(formGenerationInfo[0]);
  //         }
  //       } else {
  //         formGenerArray.push(formGenerationInfo[0]);
  //       }
  //       console.log(finalObj, "=finalObj:getProfessionalInfo");
  //       console.log(formGenerArray, "=formGenerArray:getProfessionalInfo");
  //       setUserData(finalObj);
  //       setFormGenerationInfo(formGenerArray);
  //       form.setFieldsValue(finalObj);
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       console.log(err, " = getProfessionalInfo:error");
  //       setLoading(false);
  //     });
  // }, []);

  const handleChangeInput = async (value, name, index) => {
    if (name.includes("Country")) {
      form.setFieldsValue({ [name]: value, [`City${index}`]: "" });
      setUserData((prev) => ({
        ...prev,
        [name]: value,
        [`City${index}`]: null,
      }));
    }
    // else if(name.includes("Certificate")){
    //   if(value?.length > 0){
    //     const extension = value[0].name?.split(".")[value[0]?.name?.split(".")?.length - 1];
    //     const fileName = generateRandomNumber() + extension;
    //     const response = await generatePreSignedUrl({ keys: [fileName] });
    //     console.log(response, " = response:generatePresignedUrl");
    //     const resp = await axios.put(response.data.presignedUrl, value[0].originFileObj, { headers: { ContentType: 'binary/octet-stream' } });
    //     console.log(response, " = response:uploadingPresignedUrl");
    //   }
    // }
    else {
      form.setFieldsValue({ [name]: value });
      setUserData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleAddMoreInfo = () => {
    const newArr = [...formGenerationInfo, formGenerationInfo[0]];
    setFormGenerationInfo(newArr);
  };

  const handleSave = (values) => {
    console.log(userData, " = valuesssss:ProfessionalInformationStep");
    setLoading(true);
    const dataToBeSend = [];
    let allKeys = [
      "StartDate",
      "CompanyName",
      "EmployementType",
      "Country",
      "City",
      "Certificate",
      "CurrentlyWorking",
      "Title",
      "EndDate",
    ];
    // Object.keys(userData).forEach(key => { })
    for (let i = 0, n = Object.keys(userData).length; i < n; i++) {
      if (!userData[`StartDate${i}`]) {
        break;
      }
      const obj = {};
      allKeys.forEach((key) => {
        if (key === "Certificate") {
          obj[key] =
            typeof userData[`${key + i}`] === "string"
              ? [userData[`${key + i}`]]
              : userData[`${key + i}`]?.map((cert) => cert.name || cert);
        } else if (key === "StartDate" || key === "EndDate") {
          obj[key] = dayjs(userData[`${key + i}`]).format(DATE_FORMAT);
        } else {
          obj[key] = userData[`${key + i}`];
        }
      });
      dataToBeSend.push(obj);
    }
    console.log(dataToBeSend, " = dataToBeSend:EducationalInformationStep");
    updateProfessionalInfo({ data: dataToBeSend })
      .then((res) => {
        console.log(res.data, "=res:updateEducationalInfo");
        toastMessage(res.data.message, "success");
      })
      .catch((err) => {
        console.log(err, "=err:updateEducationalInfo");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="bg-pureWhite p-5 rounded-3xl">
      {loading && <LoadingModal className="bg-gray-500/80" />}
      <p className="text-[18px] font-semibold mt-4 mb-10">
        Gold Achievement Details
      </p>
      <Form
        onFinish={handleSave}
        form={form}
        // initialValues={userData}
        defaultValue={userData}
        className="w-full mt-8 flex flex-wrap justify-between items-center gap-x-8 gap-y-5"
      >
        {formGenerationInfo?.map((info, index) => {
          return (
            <React.Fragment key={index}>
              <div
                key={index}
                className="pb-2 w-full flex flex-col items-center gap-x-8 gap-y-5"
              >
                {info?.map((data, i) => (
                  <FormItem
                    key={i + "-" + index}
                    className={`w-full px-5 sm:px-0 sm:w-full ${
                      data.type === "Checkbox" ? "lg:w-full" : ""
                    } ${data.className}`}
                    name={data.name + index}
                    rules={data.rules}
                    // dependencies={data?.dependencies}
                  >
                    <p className="text-gray-500 mt-[-4px] pl-1">{data.label}</p>
                    <CurrentInput
                      data={{ ...data, name: data.name + index }}
                      onChange={(value, name) =>
                        handleChangeInput(value, name, index)
                      }
                      formInputData={userData}
                      indexNum={index}
                      // value={userData[data.name + index]}
                    />
                  </FormItem>
                ))}
              </div>
              {formGenerationInfo?.length !== index + 1 && (
                <div className="w-full flex justify-center">
                  <div className="h-[2px] w-[70%] bg-lightOrange/50"></div>
                </div>
              )}
            </React.Fragment>
          );
        })}
        <div className="w-full flex justify-end">
          <div className="flex flex-col gap-y-2">
            <GradientButton type="button" onClick={handleAddMoreInfo}>
              <span className="">{plusIcon}</span>
              <span>Add Gold Achievement</span>
            </GradientButton>
            <button
              type="submit"
              className="rounded-full px-16 py-[4px] border-[3px] border-darkOrange hover:border-darkerOrange"
            >
              <span className="text-orange-gradient">Save Updates</span>
            </button>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default NationalBronzeAchievements;
